import {useEffect} from 'react';

export function useWarnBeforeUnload(enabled: boolean): void {
    useEffect(() => {
        if (!enabled) return undefined;

        const callback = (event: BeforeUnloadEvent): void => {
            event.preventDefault();
            // Legacy browsers (for example Chrome/Edge < 119) show the dialog only when returnValue is truthy.
            // eslint-disable-next-line no-param-reassign
            event.returnValue = true;
        };

        window.addEventListener('beforeunload', callback);
        return () => window.removeEventListener('beforeunload', callback);
    }, [enabled]);
}
